import { Form, Grid, Stack, Typography } from "@vividtheory/minerva-lab";
import { Formik } from "formik";
import React from "react";
import { z } from "zod";
import { toFormikValidationSchema } from "zod-formik-adapter";
import { Button } from "../components/Button";
import { FormikTextField } from "../components/FormikTextField";
import { IconButton } from "../components/IconButton";
import { SubmittingButton } from "../components/SubmittingButton";
import { ArrowBackOutline, DoneOutline } from "../icons";
import { LoginSignUpCodeFormModal } from "./LoginSignUpCodeFormModal";
export const LoginSignUpCodeForm = ({ isModal = false, email, onValidate, onResend, onBack, loading, variant, }) => {
    const isSignIn = variant === "signIn";
    return isModal ? (React.createElement(LoginSignUpCodeFormModal, { email: email, onValidate: onValidate, onResend: onResend, onBack: onBack, loading: loading, variant: variant })) : (React.createElement(Stack, { gap: 4, width: "100%", sx: {
            breakpoints: {
                md: {
                    padding: 4,
                },
            },
        } },
        React.createElement(IconButton, { variant: "ghost", onClick: onBack },
            React.createElement(ArrowBackOutline, { size: "xs" })),
        React.createElement(Typography, { variant: "h5", fontWeight: "bold" }, isSignIn ? "Login Code" : "Sign Up Code"),
        React.createElement(Typography, { variant: "body1", fontWeight: "regular", textColor: "disabled.onContainer" },
            "We just sent a ",
            isSignIn ? "login" : "sign up",
            " code to",
            " ",
            React.createElement(Typography, { as: "span", breakAll: true, textColor: "info.main", fontWeight: "bold" }, email),
            React.createElement("br", null),
            "Please check your inbox and enter the",
            " ",
            isSignIn ? "login" : "sign up",
            " code below."),
        React.createElement(Formik, { initialValues: { code: "" }, onSubmit: (values) => onValidate(values.code), validationSchema: toFormikValidationSchema(z.object({
                code: z.string().min(6, "Code required"),
            })), validateOnMount: true, enableReinitialize: true }, ({ handleSubmit, dirty, isValid }) => {
            return (React.createElement(Form, null,
                React.createElement(Stack, { width: "100%", gap: 4 },
                    React.createElement(FormikTextField, { autoFocus: true, name: "code", label: isSignIn ? "Login Code" : "Sign Up Code", required: true, fullWidth: true, placeholder: isSignIn
                            ? "Paste login code"
                            : "Paste sign up code", endNode: isValid ? (React.createElement(DoneOutline, { size: "xs", color: "info" })) : undefined }),
                    React.createElement(SubmittingButton, { loading: loading, onClick: () => handleSubmit(), type: "checking", disabled: !dirty || !isValid, fullWidth: true }, `Continue With ${isSignIn ? "Login" : "Sign Up"} Code`))));
        }),
        React.createElement(Grid, { container: true, gap: 1, alignItems: "center", justifyContent: "center" },
            React.createElement(Typography, { variant: "body2", fontWeight: "regular", align: "center" },
                "Haven't received the ",
                isSignIn ? "login" : "sign up",
                " code?"),
            React.createElement(Button, { variant: "outlined", density: "dense", onClick: () => onResend(email) }, "Resend"))));
};
//# sourceMappingURL=LoginSignUpCodeForm.js.map